import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IAppFormLink } from '../app-form-link';
import formLinksBuilder from '../form-links-builder';
import { FormService } from '../../services/form.service';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NavigationService } from 'app/services/navigation.service';

@Component({
  selector: 'app-create-application',
  templateUrl: './create-application.component.html',
  styleUrls: ['./create-application.component.scss']
})
export class CreateApplicationComponent implements OnInit, OnDestroy  {

  formLinks!: IAppFormLink[];
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  
  constructor(private router: Router, private formService: FormService, 
    private navigationService: NavigationService, private responsive: BreakpointObserver) {}
   
  ngOnInit(): void {
    this.formLinks = formLinksBuilder.build();
 
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }
  
  createNewApplicationForm(formName: string) {
    const link = this.formLinkByFormName(formName);
    if(link && link.formRoute && link.formRoute.commands) {
      this.formService.createUsanForm(link.formType);
      this.navigationService.sendUsanFormSectionStatesUpdate("showBasicInfoPanel");
      this.router.navigate(link.formRoute.commands, link.formRoute.extras);
    }
  }

  formLinkByFormName(name: string): IAppFormLink | undefined {
    return this.formLinks.find(({ formName }) => formName === name);
  }

  get isMobileDeviceSize() : boolean {
    return this.mobileDeviceSize;
  }
}
